<template>
  <header class="main-header" :class="{ mobile }">
    <logo @goToHomePage="goToHomePage" />
    <nav class="navbar navbar-expand-sm">
      <ul class="navbar-nav mr-auto">
        <li
          class="nav-item hamburger-link"
          v-bind:class="{ shownav: toggleDrawer }"
          @click="toggleDrawerClick"
        >
          <a class="nav-link" href="#">
            <div class="hamburger">
              <span class="line"></span>
              <span class="line1"></span>
              <span class="line2"></span>
            </div>
          </a>
        </li>
        <!-- <li v-if="isSetting" class="setting" @click="ChangeSidebar">
          <a href="#" class="nav-link">
            <b-icon-gear-fill></b-icon-gear-fill>
          </a>
        </li> -->
        <!-- <li>
          <a class="nav-link client-name">
            <span class="nt-globe"> </span> {{ tenantData }}</a
          >
        </li> -->
      </ul>

      <ul class="navbar-nav ml-auto navright-list">
        <li class="facilityseclect nav-item">
          <div class="f-selectbox">
            <!-- <facilityseclect
              :is-emp="isEmp"
              :face-id="FacilityInfo"
              v-if="isMounted"
            /> -->
          </div>
        </li>

        <b-nav-item-dropdown
          v-if="showSOS"
          right
          id="Notification"
          class="notification header-dropdown"
        >
          <template v-slot:button-content>
            <router-link class to="/sos-list">
              <b-icon-bell-fill></b-icon-bell-fill>
            </router-link>

            <div
              v-if="notification.length != 0"
              class="notifications-count active zindex"
            >
              {{ notification.length }}
            </div>
          </template>

          <b-dropdown-item href="#">
            <b-icon-envelope-fill></b-icon-envelope-fill>
            <span>Lorem Impsum</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <li
          class="nav-item myprofile"
          v-bind:class="{ showasidebar: showAsidebar }"
          @click="toggleAsidebar"
        >
          <span>
            <img
              src="../assets/images/sandy.jpg"
              class="user-image"
              alt="User Image"
            />
          </span>
        </li>
      </ul>
      <!-- <audio controls preload="none" ref="beep" hidden="true">
        <source src="../assets/audio/got-it-done.mp3" type="audio/ogg" />
      </audio>-->
    </nav>
  </header>
</template>

<script>
// import store from "@/store";
import logo from "./logo";
export default {
  props: {
    isToggle: Boolean,
  },
  components: {
    logo,
  },
  data() {
    return {
      isDrawer: false,
      showSidebar: false,
      showAsidebar: false,
      isActive: false,
      isSetting: false,
      mobile: window.innerWidth <= 1024,
      count: 0,
      isMounted: false,
      isEmp: false,
      faceId: null,

      data: {
        soundurl:
          "http://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3",
      },
    };
  },

  methods: {
    toggleDrawerClick: function () {
      this.$store.commit("toggleDrawerClick");
    },
    toggleAsidebar: function () {
      this.$root.$emit("flyoutAsidebar");
      this.showAsidebar = !this.showAsidebar;
    },
    toggleSettings() {
      this.$router.push({ name: "settings" });
    },
    goToHomePage(e) {
      localStorage.setItem("isActive", e);
    },
    ChangeSidebar() {
      this.$emit("toggleChange", {
        isToggle: (this.isActive = !this.isActive),
      });

      //localStorage.setItem("isActive", this.isActive);
      let pathName = this.isActive ? "tenantsettings" : "dashboard";
      this.$router.push({ name: pathName });
    },
    async getDataOnload() {
      //this.isActive = JSON.parse(localStorage.getItem("isActive"));
      this.faceId = this.FacilityInfo;
      if (this.userInfo == "Employee") {
        this.isEmp = true;
      }
      this.isMounted = true;
      // await this.$store.dispatch("sosList/list");

      if (this.notification.length != 0 && this.showSOS) {
        this.play();
      }
      await this.$store.dispatch("loadSettingMenu").then(() => {
        if (this.menuItem.length != 0) {
          this.isSetting = true;
        }
      });
      //await this.$store.dispatch("getTenantDetails");
    },
    play() {
      // let notify = require("@/assets/audio/got-it-done.mp3");
      var audio = new Audio(require("@/assets/audio/got-it-done.mp3"));
      audio.play();
    },
    countDown() {
      this.count = this.count + 1;
      console.log(this.count);
    },
  },

  mounted() {
    // this.$store.dispatch("loadInitialData", null, { root: true }).then(() => {
    //   this.isLoaded = this.$store.state.getInitialDataData;
    //   console.log("app", this.isLoaded);
    // });
    this.getDataOnload();

    this.$nextTick(function () {
      // window.setInterval(() => {
      //   this.$store.dispatch("sosList/list");
      //   if (this.notification.length != 0) {
      //     this.play();
      //   }
      // }, 60 * 1000);
    });
  },

  created() {
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 1024;
    });
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type == "setSeclectedFacility") {
        this.getDataOnload();
      }
    });
    // this.getDataOnload();
    // this.$refs.beep.play();
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  computed: {
    toggleDrawer() {
      return this.$store.getters.isDrawer;
    },
    tenantData() {
      return this.$store.state.oidcStore.user.Tenant;
    },
    showSOS() {
      return this.$store.state.showSOS;
    },

    userInfo() {
      return this.$store.state.oidcStore.user.role;
    },
    FacilityInfo() {
      return this.$store.state;
    },
    notification() {
      return [];
    },
    menuItem() {
      return this.$store.state.settingMenuItem;
    },
  },
  watch: {
    $route() {
      if (this.mobile) {
        this.$store.commit("toggleDrawerClose", true);
      }
    },
  },
};
</script>
<style lang="scss">
.notifications-count {
  text-align: center;

  position: absolute;
  top: 2px;
  right: 5px;
  height: 20px;
  width: 20px;

  background-color: #da3225;
  border-radius: 50%;

  color: #ffff;
}
</style>
